import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, input, OnInit, signal } from '@angular/core';
import { ListGameService } from '../../../services/lists/list-game';
import { TmpGame } from '../../templates/tmp-game/tmp-game';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Subscription, switchMap, timer } from 'rxjs';
import { AllStatus } from '../../../../core/services/status/all-status';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgScrollbarModule, provideScrollbarOptions  } from 'ngx-scrollbar';

@Component({
  selector: 'app-list-game',
  imports: [TmpGame, TranslatePipe, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, NgScrollbarModule],
  templateUrl: './list-game.html',
  styleUrl: './list-game.scss',
  //changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListGame implements OnInit {

  // games$: any = [];
  // game = signal([]);
  game = input<any>([]);
  isSearch = input<boolean>(false);

  // lists = inject(ListGameService);
  allStatus$ = inject(AllStatus);
  // subscription: Subscription;
  subscriptionDT: Subscription;
  // whenRefresh$ = timer(25000, 30000);

  isListEmpty: boolean = false;
  isReset: boolean = false;

  translate = inject(TranslateService);
  txtDialog: any;
  subscriptionCL: Subscription;

  // constructor( private ref: ChangeDetectorRef){}

  ngOnInit(): void {
    this.isListEmpty = false;
    this.loadTranslateText();
    //this.updateList();
    this.allStatus$.valueSearchList.subscribe((value: string)=>{
      if(value.length !== 0){
        this.isReset = true;      
      }else{
        this.isReset = false;
      }
    });
    this.allStatus$.updateListRoom.subscribe((value: boolean)=>{
      if(value){
        this.isReset = true;
      }else{
        this.isReset = false;
      }
    });
    this.subscriptionCL = this.allStatus$.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus$.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });   
    //this.updateAllInfo();
    this.subscriptionDT = this.allStatus$.downTime$.subscribe((follow: any)=>{
      if(follow){
        this.ngOnDestroy();
      }
    });
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  ngOnDestroy(){
 
    if(this.subscriptionDT){
      this.subscriptionDT.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }

  resetSearch(){
    this.allStatus$.textSpinner = this.txtDialog?.txtLoadingListGame;
    this.allStatus$.setDisplayProgressSpinner(true);
    this.allStatus$.setValueSearchList('reset');
  }

  updateList(){
    this.allStatus$.textSpinner = this.txtDialog?.txtLoadingListGame;
    this.allStatus$.setDisplayProgressSpinner(true);
    this.allStatus$.setUpdateListRoom(true);
  }

  // updateList(){
  //   this.lists.getListRooms().subscribe((list:any)=>{
  //     //this.game.set(list.rooms);
  //     this.allStatus$.setDisplayProgressSpinner(false);
  //     this.allStatus$.textSpinner = '';  
  //   });
  // }

  // updateAllInfo(){
  //    this.subscription = this.whenRefresh$.pipe(
  //     switchMap(() => this.lists.getListRooms())
  //   ).subscribe((list:any) =>{      
  //     //this.games$ = list.rooms;
  //     if(!this.isListEmpty){
  //       //this.game.set(list.rooms);
  //     } 
  //     //this.ref.markForCheck();
  //   });
  // }

}
